module.exports = "### Drop-in Ready\n\nMineral components are fully encapsulated, designed for composability, and ready\nto be dropped in your React project. Each will appear and behave correctly\nwithout requiring additional styles nor adversely affecting styles already\nwritten. They do what you need them to, and nothing else.\n"


//////////////////
// WEBPACK FOOTER
// ./src/website/app/pages/Home/content/dropInComponents.md
// module id = 510
// module chunks = 9